import { IApplicationState } from '../states/application.state'
import * as fromActions from '../actions/main.action'
import { Reducer } from 'redux'

export const initialState: IApplicationState = {
  count: 0,
  todo: [],
}

export const reducer: Reducer<IApplicationState> = (state: IApplicationState = initialState, { type, payload }) => {
  switch (type) {
    case fromActions.INCREASE_COUNTER:
      return {
        ...state,
        count: state.count + 1,
        payload,
      }

    case fromActions.TEST_API:
      return {
        ...state,
        todo: payload,
      }

    default:
      return state
  }
}
